// 車種マスタ（配車・定期便フォームの「車種」プルダウンの選択肢）。
// 正本は settings/vehicleTypes（raw.list）。未登録時は下記の既定23種にフォールバック。
// 保存値は従来どおり trip.vehicleClass にそのまま入る（収支の大型/中型判定は operations.js の vClass が 10t/13t/大型/増トン→大型で機能）。
import { getOne } from './collections.js'

// 請求用 車種マスタ（社内ダンプ準拠・コード01-23順）。20-23は13t・大型増トン系。
export const VEHICLE_TYPES_DEFAULT = [
  '4tw', '4tPG', '4t混載', '4t平', '4tU', '7t平', '7tU',
  '10tw', '10tPG', '10t混載', '10t冷凍', '10tU',
  '20tTR', '20fコンテナ', '40fコンテナ', '2t', '2tPG', '2t平', '3tPG',
  '13tw', '13twPG', '大型増tw', '大型増twPG',
]

// settings/vehicleTypes を読む。無ければ既定を返す（配列コピー）。
export async function loadVehicleTypes() {
  try {
    const s = await getOne('settings', 'vehicleTypes')
    const list = s && Array.isArray(s.list) ? s.list.filter((x) => typeof x === 'string' && x.trim()) : null
    if (list && list.length) return list
  } catch (e) { /* オフライン等 → 既定へ */ }
  return VEHICLE_TYPES_DEFAULT.slice()
}

const escOpt = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))

// 車種の入力欄を生成（候補付きテキスト＝選択も直接入力も可）。attr 例: 'data-f="vehicleClass"'。
// <input list> + <datalist> なので、list の19種から選んでも、リスト外の車種を手打ちしてもそのまま保存される。
// 既存値（旧「10t/4t」や日計表の生車種）は input.value にそのまま入るので取りこぼしなし。
export function vehicleTypeInput(attr, cur, list, listId = 'veil-vtypes') {
  const L = (list && list.length) ? list : VEHICLE_TYPES_DEFAULT
  const c = cur == null ? '' : String(cur)
  const opts = L.map((v) => `<option value="${escOpt(v)}"></option>`).join('')
  return `<input ${attr} list="${escOpt(listId)}" value="${escOpt(c)}" placeholder="選択 または 直接入力（例 4t平）" autocomplete="off"><datalist id="${escOpt(listId)}">${opts}</datalist>`
}
